module.exports = __webpack_public_path__ + "assets/img/306101.e4fdf6ec.svg";